import { isBuild, typeViteEnv } from '@/utils/env'
import VideoEnPlayer from '../Player'
import VideoEvents from '../event'
import { hasClass, toggleClass } from '../utils'

const publicImageUrl = isBuild() ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image' : '/resource/image'

export default class VideoLayerDom {
  player: VideoEnPlayer;
  eventInstances: VideoEvents;

  constructor(player: VideoEnPlayer, eventInstances) {
    this.player = player
    this.eventInstances = eventInstances
  }

  toggleLayerPause(state) {
    this.eventInstances.clearSetTimeOut()
    this.toggleBottomPlayState(!state)
    this.toggleCommonLayer(this.player.template.$layerState, state)

    if (state) {
      this.player.player.pause()
    } else {
      this.player.player.play()
      this.tooglePlayerBottom(true)
    }
  }

  tooglePlayerBottom(state: boolean, delay?: boolean) {
    if (state) {
      toggleClass({
        target: this.player.template.$container.parentNode as HTMLElement,
        stateType: 'remove',
        isDirect: true,
        stateClassNames: {
          remove: 'init'
        }
      })
      this.toggleCommonLayer(this.player.template.$bottom, true)
      toggleClass({
        target: this.player.template.$bottom,
        stateType: 'add',
        isDirect: true,
        stateClassNames: {
          add: 'animate__fadeInUp'
        }
      })

      setTimeout(() => {
        this.toggleCommonLayer(this.player.template.$miniProgress, false)
      })
    } else {
      if (this.eventInstances.isDragging) return
      if (this.player.template.$container) {
        if (delay) {
          if (this.eventInstances.clearBottomTime) {
            this.eventInstances.clearSetTimeOut()
          }
          this.eventInstances.clearBottomTime = setTimeout(() => {
            this.clearPlayerBottom()
          }, this.eventInstances.bottomStateTime)
        } else {
          this.clearPlayerBottom()
        }
      }
    }
  }

  clearPlayerBottom() {
    toggleClass({
      target: this.player.template.$bottom,
      stateType: 'remove',
      isDirect: true,
      stateClassNames: {
        remove: 'animate__fadeInUp'
      }
    })
    toggleClass({
      target: this.player.template.$bottom,
      stateType: 'add',
      isDirect: true,
      stateClassNames: {
        add: 'animate__fadeOutDown'
      }
    })
    setTimeout(() => {
      this.toggleCommonLayer(this.player.template.$bottom, false)
      toggleClass({
        target: this.player.template.$bottom,
        stateType: 'remove',
        isDirect: true,
        stateClassNames: {
          remove: 'animate__fadeOutDown'
        }
      })
    }, 400)

    setTimeout(() => {
      this.toggleCommonLayer(this.player.template.$miniProgress, !this.eventInstances.playerEnd)
    })
  }

  toggleBottomPlayState(state) {
    let playStateImage = ''
    if (state) {
      playStateImage = `${publicImageUrl}/player/video_play.svg`
    } else {
      playStateImage = `${publicImageUrl}/player/video_puse.svg`
    }
    this.player.template.$bottomState.setAttribute('src', playStateImage)
  }

  clearOthersLayer(type) {
    if (type !== 'all') {
      this.toggleCommonLayer(this.player.template.$loading, false)
      this.toggleCommonLayer(this.player.template.$cover, false)
      this.toggleCommonLayer(this.player.template.$miniProgress, false)
      this.toggleCommonLayer(this.player.template.$layerState, false)
      this.toggleCommonLayer(this.player.template.$bottom, false)
    }

    if (type === 'error') {
      this.toggleCommonLayer(this.player.template.$network, false)
    } else if (type === 'network') {
      this.toggleCommonLayer(this.player.template.$error, false)
    } else if (type === 'all') {
      this.toggleCommonLayer(this.player.template.$error, false)
      this.toggleCommonLayer(this.player.template.$network, false)

      if (hasClass(this.player.template.$container.parentNode as HTMLElement, 'init')) {
        this.toggleCommonLayer(this.player.template.$layerState, true)
      }
    }
  }

  toggleFixedLayer(state) {
    this.eventInstances.dragFixed = state
    if (state) {
      this.toggleCommonLayer(this.player.template.$bottom, false)
      this.toggleCommonLayer(this.player.template.$miniProgress, true)
      this.player.template.$container.style.width = this.player.options.record.rect.width > this.player.options.record.rect.height
        ? '4.96rem'
        : '2.8rem'
      this.player.template.$container.style.height = this.player.options.record.rect.width > this.player.options.record.rect.height
        ? '2.8rem'
        : '4.96rem'
      this.player.template.$container.style.position = 'fixed'
      this.player.template.$container.style.zIndex = '10000'
      this.player.template.$container.style.right = `0`
      this.player.template.$container.style.top = `${1.28 - (0.2 / 37.5)}rem`
      this.player.template.$container.style.left = 'unset'

      this.player.template.playerStateBg.style.right = `${0.6 / 37.5}rem`

      this.toggleCommonLayer(this.player.template.$miniClose, true)
      this.eventInstances.dragFixInt.handleDrag()
    } else {
      this.toggleCommonLayer(this.player.template.$miniClose, false)
      this.eventInstances.dragFixInt.removeDrag()
      const originHeight = this.player.template.$container.getAttribute('data-height')
      this.player.template.$container.style.width = '100%'
      this.player.template.$container.style.height = originHeight
      this.player.template.$container.style.position = 'relative'
      this.player.template.$container.style.zIndex = 'unset'
      this.player.template.$container.style.right = 'unset'
      this.player.template.$container.style.top = 'unset'
      this.player.template.$container.style.left = 'unset'

      this.player.template.playerStateBg.style.right = `${0.2 / 37.5}rem`
    }
  }

  toggleCommonLayer(target, state) {
    toggleClass({
      target,
      stateType: state ? 'add' : 'remove'
    })
  }
}
